import { createFileRoute } from "@tanstack/react-router";

import Error from "@/containers/Error";

export const Route = createFileRoute("/error")({
  component: () => <Error />,
});
